import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlannerPlanRoute: InvariantJiraRoute = {
	name: 'software-planner-plan',
	path: '/jira/software/projects/:projectKey/planner/:planId',
	exact: true,
};
